import { Theme } from "@mui/material";
import { colors, hoverColors } from '../../constants/colors';

const styles = {
  '& #card-container': {
    background: colors.white
  }
};

const mapStyles: any = (theme?: Theme) => styles;

export default mapStyles;